module.exports = __webpack_public_path__ + "h5/img/ren.90a749ad.png";